import i18n from '../i18n'

/**
 * Утилита для валидации сложности пароля согласно требованиям ИБ
 * Требования:
 * - Минимум 8 символов
 * - Хотя бы одна цифра
 * - Хотя бы одна заглавная буква
 * - Хотя бы одна строчная буква
 * - Хотя бы один специальный символ
 */

export const validatePasswordComplexity = (password) => {
  password = typeof password === 'string' ? password : ''
  const errors = []
  
  // Проверка минимальной длины
  if (!password || password.length < 8) {
    errors.push(i18n.global.t('errors.passwordMinLength'))
  }
  
  // Проверка наличия цифры
  if (!/\d/.test(password)) {
    errors.push(i18n.global.t('errors.passwordDigit'))
  }
  
  // Проверка наличия заглавной буквы
  if (!/[A-ZА-ЯЁӘҒҚҢӨҰҮҺІ]/.test(password)) {
    errors.push(i18n.global.t('errors.passwordUppercase'))
  }
  
  // Проверка наличия строчной буквы
  if (!/[a-zа-яёәғқңөұүһі]/.test(password)) {
    errors.push(i18n.global.t('errors.passwordLowercase'))
  }
  
  // Проверка наличия специального символа
  if (!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~`]/.test(password)) {
    errors.push(i18n.global.t('errors.passwordSpecial'))
  }
  
  return {
    isValid: errors.length === 0,
    errors: errors
  }
}

/**
 * Получить текст требований к паролю для отображения пользователю
 */
export const getPasswordRequirements = () => {
  return ['length', 'digit', 'uppercase', 'lowercase', 'special'].map(key =>
    i18n.global.t(`errors.passwordHints.${key}`)
  )
}
